<template>
  <div class="home">
    <header-com></header-com>
    <div class="main">
      <div class="cont bs">
        <h3 class="title">订单查询</h3>
        <div class="wrap">
          <el-form :inline="true" :model="formInline" size="small">
            <!-- <el-form-item style="width:200px">
              <el-input v-model="formInline.orderNo" placeholder="订单编号" clearable></el-input>
            </el-form-item>-->
            <el-form-item style="width:200px">
              <el-input v-model="formInline.orderNum" placeholder="订单编号" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item>
              <el-input v-model="formInline.content" placeholder="课程内容" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="formInline.pay" placeholder="是否支付" clearable>
                <el-option label="是" value="shanghai"></el-option>
                <el-option label="否" value="beijing"></el-option>
              </el-select>
            </el-form-item>-->
            <el-form-item style="width: 400px">
              <el-button type="primary" size="small" @click="onSearch">查询</el-button>
              <el-button type="success" size="small" @click="exportResult">导出结果</el-button>
              <!-- <el-button type="success" size="small">支付</el-button>-->
            </el-form-item>
          </el-form>
          <el-table
            :data="tableList"
            border
            max-height="640"
            :cell-style="cellStyle"
            highlight-current-row
            :header-cell-style="{background:'#dde9fc',color:'#606266'}"
            v-loading="loading"
            element-loading-text="拼命加载中"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(0, 0, 0, 0.8)"
          >
            <!-- <el-table-column type="selection" width="50"></el-table-column> -->
            <el-table-column type="index" width="50" label="序号"></el-table-column>
            <el-table-column prop="orderNum" label="订单编号" min-width="100"></el-table-column>
            <el-table-column prop="entpName" label="企业名称" min-width="100"></el-table-column>
            <el-table-column prop="orderLinkPerson" label="企业业务联络人" min-width="100"></el-table-column>
            <el-table-column prop="orderLinkPersonTel" label="联系电话" min-width="100"></el-table-column>
            <el-table-column prop="orderPackagebagName" label="课程名称" min-width="100"></el-table-column>
            <!-- <el-table-column prop="city" label="课程内容" min-width="100"></el-table-column> -->
            <el-table-column prop="orderPersoncount" label="新开账号数量" min-width="100"></el-table-column>
            <!-- <el-table-column prop="orderPrice" label="单价(元)" min-width="100"></el-table-column> -->
            <!-- <el-table-column prop="totalPrice" label="总价(元)" min-width="100"></el-table-column> -->
            <el-table-column prop="termOfValidity" label="课程有效期(天)" min-width="100"></el-table-column>
            <!-- <el-table-column prop="orderCount" label="已使用账号" min-width="100"></el-table-column> -->
            <el-table-column prop="sysCreatetime" label="下单时间" min-width="100"></el-table-column>
            <el-table-column prop="orderActive" :formatter="stateFormat" label="激活状态" width="120"></el-table-column>
          </el-table>
          <pagination
            :currentPage="currentPage"
            :total="total"
            :limit="limit"
            ref="page"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderCom from "../components/Header.vue";
import http from "../api/module";
import pagination from "../components/pagination";
import { courseURL } from "../api/baseUrl";

export default {
  name: "queryOrder",
  components: {
    HeaderCom,
    pagination
  },
  data() {
    return {
      loading: true,
      currentPage: 1, // 当前页
      limit: 20, // 每页显示数量
      total: 0, // 总条目数
      formInline: {},
      tableList: [],
      usedDialog: false,
      usedForm: {},
      applyValue: [],
      specialList: JSON.parse(sessionStorage.getItem("specialList")),
      batchList: JSON.parse(sessionStorage.getItem("batchList")),
      usedList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    // 当前页
    handleCurrentChange(val) {
      // console.log(val, "当前页");
      this.currentPage = val;
      this.getData();
    },
    // 每页数
    handleSizeChange(val) {
      this.limit = val;
      this.getData();
    },
    onSearch() {
      this.currentPage = 1;
      this.$refs.page.init();
      this.getData();
    },
    exportResult() {
      var param = "";
      var url = `${courseURL}/order/getOrderNumList?tokenId=${sessionStorage.getItem('token')}&entpId=${sessionStorage.getItem('entpId')}&export=1`;
      for (var i in this.formInline) {
        param = param + i + "=" + this.formInline[i] + "&";
      }
      param = param.slice(0, param.length - 1);
      if (param == "") {
        window.location.href = url;
      } else {
        window.location.href = url + "&" + param;
      }
    },
    getData() {
      this.loading = true;
      http
        .getOrderNumList({
          pageNum: this.currentPage,
          pageSize: this.limit,
          orderNum: this.formInline.orderNum
        })
        .then(data => {
          if (data.data.code == "200" || data.data.success == true) {
            this.loading = false;
            this.tableList = data.data.data.map(item => {
              var orderPrice = item.orderPrice.split('.')[0];
              // console.log(orderPrice,'orderPrice')
              var orderPersoncount = item.orderPersoncount;
              var totalPrice = (orderPrice * orderPersoncount) + '.00';
              item.totalPrice = totalPrice;
              return item;
            });
            this.total = data.data.total;
          } else {
            this.$message.error({
              duration: 1000,
              message: data.data.message
            });
          }
        })
        .catch(error => {});
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 9) {
        return row.orderActive == 0 ? "color:#F56C6C" : "color:#67C23A";
      } else {
        return "";
      }
    },
    stateFormat(row, column) {
      var state = row.orderActive;
      return state == "0" ? "未激活" : "已激活";
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-button--mini,
.el-button--small {
  font-size: 14px;
}
.cont {
  margin-top: 20px;
  .wrap {
    padding: 20px;
  }
  .title {
    font-size: 18px;
    line-height: 40px;
    border-bottom: 1px solid #ddd;
    padding: 0 20px;
    font-weight: normal;
  }
}
</style>
